import { makeStateKey } from '@angular/core';
import { DisplayableProductListData } from '@plp/data-access/interfaces';

export const DPLD_KEY = makeStateKey<DisplayableProductListData>('DISPLAYABLE_PRODUCT_LIST_DATA');
